import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User, Supplier, AssignUserOnBehalf, EnterVoWD } from '../_models';
import { AddVOWDComment } from '../_models/add-vowd-comment';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  Url= environment.ApiUrl + "auth";
  UserUrl= environment.ApiUrl + "user";
  constructor(private http: HttpClient) { }

  getAll() {
      return this.http.get<User[]>(`${this.Url}/all`);
  }

  getById(id: number) {
      return this.http.get<User>(`${this.Url}/getbyid/${id}`);
  }

  deleteUser(id: any) {
    return this.http.get(`${this.UserUrl}/delete/${id}`);
  }

  addUser(userInfo:User)
  {
    return this.http.post(`${this.UserUrl}/adduser`,userInfo);
  }

  assignUser(assignuser:AssignUserOnBehalf)
  {
    return this.http.post(`${this.UserUrl}/assignuser`,assignuser);
  }

  deleteAssignUser(assignuser:AssignUserOnBehalf)
  {
    return this.http.post(`${this.UserUrl}/deleteassignuser`,assignuser);
  }

  viewAssignUser(id:string) {
    return this.http.get<AssignUserOnBehalf[]>(`${this.UserUrl}/viewassignuser/${id}`);
}

viewOnBehalf(id:string) {
  return this.http.get<AssignUserOnBehalf[]>(`${this.UserUrl}/viewonbehalf/${id}`);
}

viewVOWD(id: string,month: string,behalfCAI :string) {
  return this.http.get<any[]>(`${this.UserUrl}/viewvowd/${id}/${month}/${behalfCAI}`);
}

getCostCenterList() {
  return this.http.get<any[]>(`${this.UserUrl}/getcostcenterlist`);
}


getAccountList(costcenter:String) {
  return this.http.get<string[]>(`${this.UserUrl}/getacntlist/${costcenter}`);
}

getCostCenter(ObjectAccount:String) {
  return this.http.get<string[]>(`${this.UserUrl}/getcclist/${ObjectAccount}`);
}

getContractData(SupplierID:String) {
  return this.http.get<string[]>(`${this.UserUrl}/getContractlist/${SupplierID}`);
}


CheckAccountObject(ObjectAccount:String) {
  return this.http.get<string[]>(`${this.UserUrl}/checkacntobject/${ObjectAccount}`);
}

CheckCostCenter(CostCenter:String) {
  return this.http.get<string[]>(`${this.UserUrl}/checkcostcenter/${CostCenter}`);
}

addVOWD(VowdInfo:any)
  {
    return this.http.post(`${this.UserUrl}/addvowd`,VowdInfo);
  }

UpdateVOWD(VowdInfo:EnterVoWD)
  {
    return this.http.post(`${this.UserUrl}/UpdateVOWD`,VowdInfo);
  }

SubmitVOWD(VowdInfo: any[])
  {
    return this.http.post(`${this.UserUrl}/submitvowd`,VowdInfo);
  }

getCurrency() {
    return this.http.get<any[]>(`${this.UserUrl}/GetCurrency`);
  }

getVOWDComment(Period:string,CreatedBy:string,OnBehalf:string) {
    return this.http.get<any[]>(`${this.UserUrl}/getvowdcomment/${Period}/${CreatedBy}/${OnBehalf}`);
  }

addVOWDComment(VowdComment:AddVOWDComment[])
  {
    return this.http.post(`${this.UserUrl}/addvowdcomment`,VowdComment);
  }

checkVOWDDuplicate(supplierAB: number,objectAcnt: string,costCenter :string,period:string) {
    return this.http.get<any[]>(`${this.UserUrl}/checkVOWDDuplicate/${supplierAB}/${objectAcnt}/${costCenter}/${period}`);
  }

checkVOWDDuplicateByContract(supplierAB: number,objectAcnt: string,costCenter :string,period:string,ContractId:string) {    
  
    if(ContractId == ""){
      ContractId = '0';
    }
    return this.http.get<any[]>(`${this.UserUrl}/checkVOWDDuplicate/${supplierAB}/${objectAcnt}/${costCenter}/${period}/${ContractId}`);
  }

getSasbuUserList() {
    return this.http.get<any[]>(`${this.UserUrl}/getsasbuuserlist`);
  }

  
  getExceptionSuppliers(SupplierID:string) {
    return this.http.get<Supplier[]>(`${this.UserUrl}/getexceptionsuppliers/${SupplierID}`);
  }

  getRemainingAmount(SupplierId:string,ContractId:string) {
    return this.http.get<any[]>(`${this.UserUrl}/getremainingcontractamount/${SupplierId}/${ContractId}`);
  }

}
